module.exports = __webpack_public_path__ + "static/img/ctx.ae32d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctx.png
// module id = 411
// module chunks = 2